import Topics from './container';

export default Topics;



// WEBPACK FOOTER //
// ./src/components/Topics/index.js